import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { datepickerModePeriodicidade, periodicidadeAnual } from '../../../../shared';
import { DatepickerComponent } from '../../../../shared/components/datepicker';
import { ClienteAnaliseMercadoFilter } from '../../adapters';

@Component({
    selector: 'sgt-cliente-analise-mercado-periodicidade-filter',
    templateUrl: './cliente-analise-mercado-periodicidade-filter.component.html',
    styleUrls: ['./cliente-analise-mercado-periodicidade-filter.component.less']
})
export class ClienteAnaliseMercadoPeriodicidadeFilterComponent {
    /** Filtro da análise de mercado */
    @Input() filter: ClienteAnaliseMercadoFilter;
    /** Se o filtro está inicializado */
    @Input() isFilterInitialized: boolean;

    /** Ao alterar a data da periodicidade */
    @Output() periodicidadeDataChange = new EventEmitter<any>();

    // Datepicker
    @ViewChild('dataDatepicker') dataDatepicker: DatepickerComponent;
    datepickerMode = datepickerModePeriodicidade.id;
    isFirstChangeData = true;

    /** Inicia a periodicidade */
    initPeriodicidade(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            // Se não possuir ano no filtro, então setamos o ano atual
            if (!this.filter.possuiAno()) {
                await this.setAnoAtual();
            }

            resolve();
        });
    }

    /** Seta o ano do filtro com o ano atual */
    private setAnoAtual(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            const data = new Date();
            data.setDate(1); // Setando sempre o dia 1;

            this.filter.periodicidade = periodicidadeAnual.id;
            await this.dataDatepicker?.setPeriodicidade(periodicidadeAnual, data);
            resolve();
        });
    }

    /** Seta a periodicidade para anual */
    setPeriodicidadeAnual(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            this.filter.periodicidade = periodicidadeAnual.id;
            await this.dataDatepicker.setPeriodicidade(periodicidadeAnual, this.filter.data);
            resolve();
        });
    }

    /** Ao alterar a periodicidade do datepicker */
    onChangePeriodicidade(periodicidade: number) {
        this.filter.periodicidadeSelecionada = periodicidade;
    }

    /** Ao alterar a data */
    onChangeData() {
        if (this.isFirstChangeData) {
            this.isFirstChangeData = false;
            return;
        }

        this.periodicidadeDataChange.emit();
    }

    /** Seta o foco no datepicker da data */
    setFocus() {
        this.dataDatepicker?.setFocus();
    }


    /** Retorna o ano sendo filtrado */
    getAno(): number {
        return this.filter.ano ?? null;
    }
}
